const tenants = {
    title: 'การตั้งค่า',
    description: 'จัดการการตั้งค่าผู้เช่าอย่างมีประสิทธิภาพและปรับแต่งโดเมนของคุณ',
    tabs: {
        settings: 'การตั้งค่า',
        members: 'สมาชิก',
        domains: 'โดเมน',
        subscription: 'แผนและการเรียกเก็บเงิน',
        billing_history: 'ประวัติการเรียกเก็บเงิน',
    },
    settings: {
        title: 'การตั้งค่า',
        description: 'ตั้งชื่อผู้เช่าและดูภูมิภาคโฮสต์ข้อมูลของคุณและประเภทผู้เช่า',
        tenant_id: 'รหัสผู้เช่า',
        tenant_name: 'ชื่อผู้เช่า',
        tenant_instance: 'เลือกอินสแตนซ์ของคุณ',
        tenant_instance_description: 'เลือกสถานที่โฮสต์สำหรับผู้เช่าของคุณ เลือก Logto Cloud สำหรับโครงสร้างพื้นฐานที่ใช้ร่วมกันสาธารณะ หรืออินสแตนซ์ส่วนตัวสำหรับทรัพยากรเฉพาะ',
        tenant_region: 'ภูมิภาคข้อมูล',
        tenant_region_description: 'ตำแหน่งทางกายภาพที่ทรัพยากรผู้เช่าของคุณ (ผู้ใช้, แอปพลิเคชัน ฯลฯ) ถูกโฮสต์ ไม่สามารถเปลี่ยนแปลงได้หลังจากสร้างแล้ว',
        tenant_region_tip: 'ทรัพยากรผู้เช่าของคุณถูกรองรับใน {{region}} <a>เรียนรู้เพิ่มเติม</a>',
        environment_tag_development: 'ทดสอบ',
        environment_tag_production: 'โปรดักชั่น',
        tenant_type: 'ประเภทผู้เช่า',
        development_description: 'ใช้สำหรับทดสอบเท่านั้นและไม่ควรใช้ในโปรดักชั่น ไม่ต้องการการสมัครสมาชิก มีทุกฟีเจอร์โปรแต่มีข้อจำกัด เช่น แบนเนอร์เข้าสู่ระบบ',
        production_description: 'สำหรับแอปที่ถูกใช้งานโดยผู้ใช้งานจริงและอาจต้องการการสมัครสมาชิกแบบชำระเงิน',
        tenant_info_saved: 'บันทึกข้อมูลผู้เช่าสำเร็จ',
        tenant_mfa: 'การยืนยันตัวตนหลายปัจจัย',
        tenant_mfa_description: 'กำหนดให้สมาชิกของคุณตั้งค่าการยืนยันตัวตนหลายปัจจัยเพื่อเข้าถึงผู้เช่านี้',
        enterprise_sso: 'Enterprise SSO',
        enterprise_sso_description: 'มีให้บริการในแผนชำระเงิน ติดต่อเราเพื่อเปิดใช้งาน Enterprise SSO เพื่อให้สมาชิกทุกคนสามารถลงชื่อเข้าใช้คอนโซล Logto Cloud โดยใช้ผู้ให้บริการตัวตนขององค์กรของคุณ',
    },
    full_env_tag: {
        development: 'ทดสอบ',
        production: 'โปรดักชั่น',
    },
    deletion_card: {
        title: 'ลบ',
        tenant_deletion: 'ลบผู้เช่า',
        tenant_deletion_description: 'การลบผู้เช่าจะเป็นการลบข้อมูลผู้ใช้และการตั้งค่าทั้งหมดที่เกี่ยวข้องอย่างถาวร โปรดดำเนินการด้วยความระมัดระวัง',
        tenant_deletion_button: 'ลบผู้เช่า',
    },
    leave_tenant_card: {
        title: 'ออกจาก',
        leave_tenant: 'ออกจากผู้เช่า',
        leave_tenant_description: 'ทรัพยากรในผู้เช่าจะยังคงอยู่แต่คุณจะไม่สามารถเข้าถึงผู้เช่านี้ได้อีก',
        last_admin_note: 'หากต้องการออกจากผู้เช่านี้ กรุณาตรวจสอบว่ามีสมาชิกอื่นอย่างน้อยหนึ่งคนที่มีบทบาทผู้ดูแลระบบ',
    },
    create_modal: {
        title: 'สร้างผู้เช่า',
        subtitle: 'สร้างผู้เช่าใหม่ที่มีทรัพยากรและผู้ใช้แยกต่างหาก',
        tenant_id: 'รหัสผู้เช่า',
        tenant_usage_purpose: 'คุณต้องการใช้ผู้เช่านี้เพื่ออะไร?',
        development_description: 'ใช้สำหรับทดสอบเท่านั้นและไม่ควรใช้ในโปรดักชั่น ไม่ต้องการการสมัครสมาชิก',
        development_description_for_private_regions: 'ใช้สำหรับทดสอบเท่านั้นและไม่ควรใช้ในโปรดักชั่น',
        development_hint: 'มีทุกฟีเจอร์โปรแต่มีข้อจำกัด เช่น แบนเนอร์เข้าสู่ระบบ',
        production_description: 'สำหรับการใช้งานโดยผู้ใช้จริงและอาจต้องมีการสมัครสมาชิกแบบชำระเงิน',
        available_plan: 'แผนที่สามารถใช้งานได้:',
        create_button: 'สร้างผู้เช่า',
        tenant_name_placeholder: 'ผู้เช่าของฉัน',
        tenant_created: 'สร้างผู้เช่าสำเร็จ',
        invitation_failed: 'การเชิญบางรายการส่งไม่สำเร็จ กรุณาลองอีกครั้งใน การตั้งค่า -> สมาชิก ในภายหลัง',
        tenant_type_description: 'ไม่สามารถเปลี่ยนแปลงได้หลังจากสร้างแล้ว',
        tenant_id_invalid: 'รหัสผู้เช่าสามารถประกอบด้วยตัวอักษรพิมพ์เล็ก ตัวเลข และเครื่องหมายขีดกลางเท่านั้น และต้องไม่เกิน {{max}} ตัวอักษร',
        tenant_id_placeholder: 'รหัสผู้เช่าของคุณ',
        tenant_id_tip: 'กำหนดรหัสผู้เช่าเอง หากเว้นว่างไว้ Logto จะสร้างรหัสเริ่มต้น รหัสผู้เช่าไม่สามารถเปลี่ยนแปลงได้หลังจากสร้างแล้ว',
    },
    dev_tenant_migration: {
        title: 'ตอนนี้คุณสามารถทดลองใช้ฟีเจอร์ Pro ของเราได้ฟรี โดยสร้าง "ผู้เช่าสำหรับทดสอบ" ใหม่!',
        affect_title: 'มีผลกระทบกับคุณอย่างไร?',
        hint_1: 'เรากำลังแทนที่ <strong>แท็กสภาพแวดล้อมเดิม</strong> ด้วยประเภทผู้เช่าใหม่สองรายการ: <strong>“ทดสอบ”</strong> และ <strong>“โปรดักชั่น”</strong>',
        hint_2: 'เพื่อให้เปลี่ยนผ่านได้อย่างราบรื่นและการทำงานไม่สะดุด ผู้เช่าทั้งหมดที่ถูกสร้างขึ้นก่อนหน้านี้จะถูกอัปเกรดเป็นประเภทผู้เช่า <strong>โปรดักชั่น</strong> พร้อมกับแผนการสมัครสมาชิกของคุณเดิม',
        hint_3: 'ไม่ต้องกังวล การตั้งค่าอื่นๆ ของคุณจะเหมือนเดิม',
        about_tenant_type: 'เกี่ยวกับประเภทผู้เช่า',
    },
    delete_modal: {
        title: 'ลบผู้เช่า',
        description_line1: 'คุณแน่ใจหรือว่าต้องการลบผู้เช่า "<span>{{name}}</span>" พร้อมแท็กสภาพแวดล้อม "<span>{{tag}}</span>"? การดำเนินการนี้ไม่สามารถย้อนกลับ และจะลบข้อมูลและรายละเอียดผู้เช่าทั้งหมดอย่างถาวร',
        description_line2: 'ก่อนลบผู้เช่า เราอาจช่วยคุณได้ <span><a>ติดต่อเราทางอีเมล</a></span>',
        description_line3: 'หากต้องการดำเนินการต่อ กรุณากรอกชื่อผู้เช่า "<span>{{name}}</span>" เพื่อยืนยัน',
        delete_button: 'ลบอย่างถาวร',
        cannot_delete_title: 'ไม่สามารถลบผู้เช่านี้ได้',
        cannot_delete_description: 'ขออภัย คุณไม่สามารถลบผู้เช่านี้ได้ในตอนนี้ กรุณาตรวจสอบว่าคุณใช้งานแผนฟรีและชำระค่าใช้จ่ายทั้งหมดแล้ว',
    },
    leave_tenant_modal: {
        description: 'คุณแน่ใจหรือว่าต้องการออกจากผู้เช่านี้?',
        leave_button: 'ออกจาก',
    },
    tenant_landing_page: {
        title: 'คุณยังไม่ได้สร้างผู้เช่า',
        description: 'เพื่อเริ่มต้นตั้งค่าโปรเจ็กต์กับ Logto กรุณาสร้างผู้เช่าใหม่ หากต้องการออกจากระบบหรือลบบัญชีของคุณ เพียงคลิกที่ปุ่มอวาตาร์ตรงมุมขวาบน',
        create_tenant_button: 'สร้างผู้เช่า',
    },
    status: {
        mau_exceeded: 'เกินจำนวน MAU',
        token_exceeded: 'เกินจำนวนโทเคน',
        suspended: 'ถูกระงับ',
        overdue: 'เกินกำหนดชำระเงิน',
    },
    tenant_suspended_page: {
        title: 'ผู้เช่าถูกระงับ ติดต่อเราเพื่อกู้คืนการเข้าถึง',
        description_1: 'เราขออภัยที่ต้องแจ้งให้ทราบว่าบัญชีผู้เช่าของคุณถูกระงับชั่วคราว เนื่องจากการใช้งานไม่ถูกต้อง เช่น เกินข้อจำกัด MAU, ชำระเงินล่าช้า หรือดำเนินการที่ไม่ได้รับอนุญาต',
        description_2: 'หากคุณต้องการคำชี้แจงเพิ่มเติม มีข้อกังวล หรือประสงค์จะกู้คืนสิทธิ์การใช้งานและปลดล็อกผู้เช่าของคุณ กรุณาติดต่อเราได้ทันที',
    },
    production_tenant_notification: {
        text: 'ตอนนี้คุณอยู่ในผู้เช่าสำหรับทดสอบฟรี สร้างผู้เช่าโปรดักชั่นเพื่อใช้งานจริง',
        action: 'สร้างผู้เช่า',
    },
};
export default Object.freeze(tenants);
